// ** Initial State
const initialState = {
  orderStatusUpdates: {
    data: [],
    paginationMeta: {
      page: 1,
      pageSize: 20,
      total: 0,
      totalPages: 0,
    },
  },
};

const orderEvents = (state = initialState, action) => {
  switch (action.type) {
  case 'GET_ORDERS_STATUS_UPDATES_(M)':
    return {
      ...state,
      orderStatusUpdates: {
        data: action.data.data,
        paginationMeta: {
          page: action.data.page,
          pageSize: action.data.pageSize,
          total: action.data.total,
          totalPages: action.data.totalPages,
        },
      },
    };
  default:
    return { ...state };
  }
};
export default orderEvents;
